import { Flex } from '@chakra-ui/react'

import '@/components/ambient/animations.css'
import { LoginForm } from './components/loginForm'

function LoginPage() {
  return (
    <Flex
      minH="100vh"
      minW="100vw"
      align="center"
      justify="center"
      bg="bg.primary"
      position="relative"
      overflow="hidden"
    >
      <LoginForm />
    </Flex>
  )
}

export default LoginPage
